import script from "./RightSearchDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./RightSearchDrawer.vue?vue&type=script&setup=true&lang=js"

import "./RightSearchDrawer.vue?vue&type=style&index=0&id=7a8cafd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a8cafd4"]])

export default __exports__